<template>
  <div>
    <CRow>
      <CCol col>
        <CCard>
          <CCardHeader>
            <strong> Modulo Categoria de Producto  - Editar</strong>
          </CCardHeader>
          <CCardBody>
            <b-form id="Form" @submit.prevent="Validate">
              <b-row>
                
                <b-col md="3">
                  <div class="w-100 text-center">
                     <img class="img-fluid" :src="previewImage">
                  </div>
                  <b-col md="12">
                    <b-form-group label="Foto: ">
                      <b-form-file @change="PreviewImage" accept="image/*" v-model="photo" placeholder="Seleccione un foto..." drop-placeholder="Suelta la imagen aquí..."></b-form-file>
                      <small class="form-text text-center text-secondary">Tamaño recomendado 400px x 500px</small>
                    </b-form-group>
                  </b-col>
                </b-col>

                <b-col md="9">
                  <b-row>
                      <b-col md="12">
                        <b-form-group label="Nombre:">
                          <b-form-input type="text" v-model="category_product.name" placeholder="Ingrese un nombre"></b-form-input>
                          <small v-if="errors.name" class="form-text text-danger">Ingrese un nombre</small>
                        </b-form-group>
                      </b-col>
              
                      <b-col md="12">
                        <b-form-group label="Descripción :">
                          <b-form-input type="text" placeholder="Ingrese una descripción" v-model="category_product.description"></b-form-input>
                        </b-form-group>
                      </b-col>
                      
                      <b-col md="6">
                        <b-form-group label="Clasificación :">
                          <b-form-select v-model="category_product.classification" :options="classification"></b-form-select>
                        </b-form-group>
                      </b-col>

                      <b-col md="6">
                        <b-form-group label="Estado :">
                          <b-form-select v-model="category_product.state" :options="state"></b-form-select>
                        </b-form-group>
                      </b-col>

                      <b-col md="5"></b-col>
                      <b-col md="2">
                        <b-button type="submit" class="form-control" variant="primary" ><i class="fas fa-save"></i> Guardar (F4)</b-button>
                      </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </b-form>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

     <LoadingComponent :is-visible="isLoading"/>
    <Keypress key-event="keyup" :key-code="115" @success="Validate" />
  </div>
</template>

<script>
const axios = require("axios").default;
const Swal = require("sweetalert2");
const je = require("json-encrypt");
import { mapState } from "vuex";
import LoadingComponent from './../pages/Loading'
export default {
  name: "CategoryEdit",
  props: ["id_category_product"],
  components:{
      Keypress: () => import('vue-keypress'),
    LoadingComponent,
  },
  data() {
    return {
      isLoading: false,
      module: 'CategoryProduct',
      category_product: {
        name: "",
        description: "",
        photo: "",
        classification: 1,
        state: 1,
      },
      classification:[
        {value:1,text:'Productos'},
        {value:0,text:'Ingredientes'},
      ],
      state:[
        {value:1,text:'Activo'},
        {value:0,text:'Inactivo'},
      ],
      previewImage: 'https://loisjeans.id/skin/frontend/base/default/images/catalog/product/placeholder/image.jpg',
      photo: null,
      errors: {
        name: false,
        photo:false,
      },
      validate: false,
    };
  },
  mounted() {
    this.ViewCategory();
  },
  methods: {
    ViewCategory,
    EditCategory,
    Validate,
    PreviewImage,
  },

  computed: {
    ...mapState(["url_base"]),
    token: function () {
      let user = window.localStorage.getItem("user");
      user = JSON.parse(JSON.parse(je.decrypt(user)));
      return user.api_token;
    },
  },
};
function PreviewImage(event) {
  var input = event.target;
  if (input.files && input.files[0]) {
      var reader = new FileReader();
      reader.onload = (e) => {
          this.previewImage = e.target.result;
      }
      reader.readAsDataURL(input.files[0]);
  }
  this.category_product.photo = input.files[0];
}
//ver usuario
function ViewCategory() {
  let id_category_product = je.decrypt(this.id_category_product);
  let me = this;
  let url = this.url_base + "category-product/view/" + id_category_product;
  me.isLoading = true;
  axios({
    method: "GET",
    url: url,
    headers: { token: this.token, module: this.module, role: 3,},
  })
    .then(function (response) {
      if (response.data.status == 200) {
        me.category_product.id_category_product = response.data.result.id_category_product;
        me.category_product.name = response.data.result.name;
        me.category_product.photo = '';
        me.category_product.description = response.data.result.description;
        me.category_product.classification = response.data.result.classification;
        me.category_product.state = response.data.result.state;
        me.previewImage = me.url_base + response.data.result.photo;
      } else {
        Swal.fire({ icon: 'error', text: response.data.message, timer: 3000,})
      }
      me.isLoading = false;
    })
    .catch((error) => {
      Swal.fire({ icon: 'error', text: 'A ocurrido un error', timer: 3000,})
      me.isLoading = false;
    });
}

//editar usuario
function EditCategory(_this) {
  

  let me = _this;
  let url = me.url_base + "category-product/edit";
  let data = new FormData();
  data.append("id_category_product", me.category_product.id_category_product);
  data.append("name", me.category_product.name);
  data.append("description", me.category_product.description);
  data.append("photo", me.category_product.photo);
  data.append("classification", me.category_product.classification);
  data.append("state", me.category_product.state);
  axios({
    method: "POST",
    url: url,
    data: data,
    headers: { "Content-Type": "application/json", token: me.token, module: me.module, role: 3},
  })
    .then(function (response) {
      if (response.data.status == 200) {
        me.photo = null;
        Swal.fire({ icon: 'success', text:response.data.message, timer: 3000,})
      } else {
        Swal.fire({ icon: 'error', text:response.data.message, timer: 3000,})
      }
    })
    .catch((error) => {
      Swal.fire({ icon: 'error', text: 'A ocurrido un error', timer: 3000,})
    });
}

//validacion de formulario
function Validate() {
  this.errors.name = this.category_product.name.length == 0 ? true : false;
  this.errors.state = this.category_product.state.length == 0 ? true : false;
  
  if (this.errors.name) { this.validate = true; Swal.fire({ icon: 'warning', text: 'Verifique que campos necesarios esten llenados', timer: 2000,}); return false;}else{ this.validate = false; }
  if (this.errors.state) { this.validate = true; Swal.fire({ icon: 'warning', text: 'Verifique que campos necesarios esten llenados', timer: 2000,}); return false;}else{ this.validate = false; }

  let me = this;

   if (!this.validate) {
    Swal.fire({
      title: "Esta seguro de modificar la categoria ?",
      text: "",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, Estoy de acuerdo!",
    }).then((result) => {
      if (result.value) {
        this.EditCategory(me);
      }
    });

  }
}
</script>
